import TableAntd from '@/components/TableAntd'
import { Button, Row, Space, Tooltip } from 'antd'
import Search from '@/components/SearchFilter'
import useHook from './hook'
import { formName } from '@/components/SearchFilter/formItem'
import { useMemo, useRef } from 'react'
import ImportTemplateModal from '@/components/ImportTemplateModal'
import { Template_url_inquiryImportSCP } from '@/api/template'
;('@/components/SearchFilter/TemplateData')
// import { InquiryOrderSuper } from '@/api/inquiry'
import { Tag as TagType } from './reducer'
import { InquiryOrderItemDTO, Status } from '@/api/inquiry'
import { formatTime } from '@/tools/util'
import RadioTabs from '@/components/RadioTabs'
import AsyncButton from '@/components/AsyncButton'
import {
  supplierInquiryItemStatusEnum,
  textGoldClassname,
  textRedClassname,
} from '@/global/enum'
import { AttachmentPreview } from '../inquiryDetail/components/AttachmentPreview'

export enum StatusSearchDataEnum {
  ALL = 3,
  PENDING = 1,
  COMPLETED = 2,
}

/**
 *
 * @param status
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 * @returns
 */

const getInquiryStatusName = (status: string) => {
  const statusMap = {
    [Status.The0]: '待接单',
    [Status.The1]: '待报价',
    [Status.The2]: '已报价',
    [Status.The3]: '待重新报价',
    [Status.The4]: '采购方取消',
  }
  return statusMap[status as unknown as keyof typeof statusMap] || status
}

// 根据截止日期获取状态显示
const getExpireDateStatus = (record: InquiryOrderItemDTO) => {
  const expireDate = record.expireDate
  const init = {
    text: '',
    className: '',
  }

  if (record.tags?.includes('即将到期')) {
    init.className = textGoldClassname
    init.text = '3天内到期'
  } else if (record.tags?.includes('已到期')) {
    init.className = textRedClassname
    init.text = '已到期'
  }
  return init
}

// 票据
const fileListItems: formName[] = [
  'inquiryNo',
  'groupName',
  'inquiryDateStart',
  'inquiryDateEnd',
  // 'quotationTimeStart',
  // 'quotationTimeEnd',
  'startExpireDate',
  'endExpireDate',
  'purchaserName',
  'materialCount',
  'status',
  'itemStatus',
  'inquiryTaskNo',
  'clientMaterialName',
  'clientMaterialQty',
]

const XhQuotation = () => {
  const filterSlotRef = useRef<HTMLSpanElement>(null)
  const {
    onSearch,
    state,
    onRefresh,
    onChange,
    onChangeCheck,
    onBatchExport,
    handleChange,
    handleStatusChange,
    jumpDetail,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
  } = useHook()

  const {
    dataSource,
    loading,
    pages,
    tagsData,
    countData,

    statusSearchData,
  } = state

  // 将状态选项转换为 RadioTabs 需要的格式
  const radioItemDict = useMemo(() => {
    return {
      [StatusSearchDataEnum.PENDING]: {
        value: `未完结（${countData.unfinishedCount}）`,
      },
      [StatusSearchDataEnum.COMPLETED]: {
        value: `已完结（${countData.finishedCount}）`,
      },
      [StatusSearchDataEnum.ALL]: {
        value: `全部（${countData.totalCount}）`,
      },
    }
  }, [countData])

  const getColumn = [
    {
      key: 'inquiryNo',
      title: '询价单号',
      width: 150,
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        const { tags } = record

        return (
          <div style={{ display: 'flex' }}>
            <Button type="link" onClick={() => jumpDetail(record)}>
              {text}
            </Button>
            <span style={{ marginLeft: 20 }}>
              {tags?.map((tag) => (
                <Tooltip title={tag} getTooltipContainer={() => document.body}>
                  {tag === '急单' ? '🔥' : '⚡️'}
                </Tooltip>
              ))}
            </span>
          </div>
        )
      },
    },
    {
      key: 'groupName',
      title: '询价公司名称',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },
    {
      key: 'createdAt',
      title: '询价日期',
      width: 200,
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return <span>{formatTime(text, 'YYYY-MM-DD')}</span>
      },
    },
    {
      key: 'expireDate',
      title: '询价截止日期',
      width: 200,
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        const status = getExpireDateStatus(record)
        return (
          <span className={status.className}>
            {formatTime(text, 'YYYY-MM-DD')}
            {status.text && <span> ({status.text})</span>}
          </span>
        )
      },
    },
    {
      key: 'purchaserName',
      title: '采购员',
      width: 100,
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },

    {
      key: 'materialCount',
      title: '物料条数',
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },
    {
      key: 'statusText',
      title: '状态',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return getInquiryStatusName(text)
      },
    },
    {
      key: 'attachment',
      title: '附件',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text ? (
          <AttachmentPreview attachment={text} splitor={','} clickDownload />
        ) : (
          ''
        )
      },
    },
    {
      key: 'sortOrder',
      title: '序号',
      width: 80,
      render(text: number, record: InquiryOrderItemDTO, index: number) {
        return text ?? index + 1
      },
    },
    {
      key: 'itemStatusText',
      title: '明细状态',
      render(text: string) {
        return (
          <span
            className={supplierInquiryItemStatusEnum.getAttrByLabel(
              text as any,
              'className',
            )}
          >
            {text}
          </span>
        )
      },
    },
    {
      key: 'inquiryTaskNo',
      title: '来源唯一标识码',
      render(text: string) {
        return text || ''
      },
    },
    {
      key: 'clientMaterialName',
      title: '客方物料名称',
      render(text: string) {
        return text || ''
      },
    },
    {
      key: 'clientMaterialQty',
      title: '数量',
      width: 80,
      render(text: number) {
        return text || ''
      },
    },
  ]

  return (
    <div>
      <Search
        keyName={'INQUIRYLIST'}
        ScreenKey={'INQUIRYLIST'}
        fieldsData={fileListItems}
        onSearch={onSearch}
      />
      <div style={{ padding: '0 10px' }}>
        <div style={{ width: '40%', margin: '10px 0' }}>
          <RadioTabs
            defaultKey={String(statusSearchData)}
            radioItemDict={radioItemDict}
            onChange={(key) => handleStatusChange(Number(key))}
          />
        </div>
        <div style={{ margin: '10px 0' }}>
          <Row justify={'space-between'}>
            <Space size={'small'}>
              {tagsData.map((tag: TagType) => (
                <div
                  key={tag.value}
                  className={tag.checked ? 'filter-btn-active' : 'filter-btn'}
                  onClick={() => handleChange(tag.value)}
                >
                  {tag.label}
                </div>
              ))}
            </Space>
            <Space>
              <ImportTemplateModal
                buttonText="批量导入结果"
                modalTitle="批量导入结果"
                open={state.importModalOpen}
                onOpenChange={onImportOpenChange}
                confirmLoading={state.importConfirmLoading}
                onConfirm={onConfirmImport}
                downloadConfig={{
                  url: Template_url_inquiryImportSCP,
                }}
                uploadProps={{
                  dataSource: state.importUploadList,
                  onChange: onImportFileChange,
                  getOriginFile: getImportOriginFile,
                  type: 'inquiryImportSCP',
                }}
              />
              <AsyncButton onClick={onBatchExport}>批量导出</AsyncButton>
              <span ref={filterSlotRef} />
            </Space>
          </Row>
        </div>

        <TableAntd
          loading={loading}
          dataSource={dataSource.data}
          listColumn={getColumn}
          showSort
          Y={420}
          rowKey="inquiryItemId"
          filterType="咸亨询价单"
          ScreenColOnlyKey={['inquiryNo']}
          filterSlotRef={filterSlotRef}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
          onChangeCheck={onChangeCheck}
          showSize
        />
      </div>
    </div>
  )
}

export default XhQuotation
import TableAntd from '@/components/TableAntd'
import { Button, Row, Space, Tooltip } from 'antd'
import Search from '@/components/SearchFilter'
import useHook from './hook'
import { formName } from '@/components/SearchFilter/formItem'
import { useMemo, useRef } from 'react'
import ImportTemplateModal from '@/components/ImportTemplateModal'
import { Template_url_inquiryImportSCP } from '@/api/template'
;('@/components/SearchFilter/TemplateData')
// import { InquiryOrderSuper } from '@/api/inquiry'
import { Tag as TagType } from './reducer'
import { InquiryOrderItemDTO, Status } from '@/api/inquiry'
import { formatTime } from '@/tools/util'
import RadioTabs from '@/components/RadioTabs'
import AsyncButton from '@/components/AsyncButton'
import {
  supplierInquiryItemStatusEnum,
  textGoldClassname,
  textRedClassname,
} from '@/global/enum'
import { AttachmentPreview } from '../inquiryDetail/components/AttachmentPreview'

export enum StatusSearchDataEnum {
  ALL = 3,
  PENDING = 1,
  COMPLETED = 2,
}

/**
 *
 * @param status
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 * @returns
 */

const getInquiryStatusName = (status: string) => {
  const statusMap = {
    [Status.The0]: '待接单',
    [Status.The1]: '待报价',
    [Status.The2]: '已报价',
    [Status.The3]: '待重新报价',
    [Status.The4]: '采购方取消',
  }
  return statusMap[status as unknown as keyof typeof statusMap] || status
}

// 根据截止日期获取状态显示
const getExpireDateStatus = (record: InquiryOrderItemDTO) => {
  const expireDate = record.expireDate
  const init = {
    text: '',
    className: '',
  }

  if (record.tags?.includes('即将到期')) {
    init.className = textGoldClassname
    init.text = '3天内到期'
  } else if (record.tags?.includes('已到期')) {
    init.className = textRedClassname
    init.text = '已到期'
  }
  return init
}

// 票据
const fileListItems: formName[] = [
  'inquiryNo',
  'groupName',
  'inquiryDateStart',
  'inquiryDateEnd',
  // 'quotationTimeStart',
  // 'quotationTimeEnd',
  'startExpireDate',
  'endExpireDate',
  'purchaserName',
  'materialCount',
  'status',
  'itemStatus',
  'inquiryTaskNo',
  'clientMaterialName',
  'clientMaterialQty',
]

const XhQuotation = () => {
  const filterSlotRef = useRef<HTMLSpanElement>(null)
  const {
    onSearch,
    state,
    onRefresh,
    onChange,
    onChangeCheck,
    onBatchExport,
    handleChange,
    handleStatusChange,
    jumpDetail,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
  } = useHook()

  const {
    dataSource,
    loading,
    pages,
    tagsData,
    countData,

    statusSearchData,
  } = state

  // 将状态选项转换为 RadioTabs 需要的格式
  const radioItemDict = useMemo(() => {
    return {
      [StatusSearchDataEnum.PENDING]: {
        value: `未完结（${countData.unfinishedCount}）`,
      },
      [StatusSearchDataEnum.COMPLETED]: {
        value: `已完结（${countData.finishedCount}）`,
      },
      [StatusSearchDataEnum.ALL]: {
        value: `全部（${countData.totalCount}）`,
      },
    }
  }, [countData])

  const getColumn = [
    {
      key: 'inquiryNo',
      title: '询价单号',
      width: 150,
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        const { tags } = record

        return (
          <div style={{ display: 'flex' }}>
            <Button type="link" onClick={() => jumpDetail(record)}>
              {text}
            </Button>
            <span style={{ marginLeft: 20 }}>
              {tags?.map((tag) => (
                <Tooltip title={tag} getTooltipContainer={() => document.body}>
                  {tag === '急单' ? '🔥' : '⚡️'}
                </Tooltip>
              ))}
            </span>
          </div>
        )
      },
    },
    {
      key: 'groupName',
      title: '询价公司名称',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },
    {
      key: 'createdAt',
      title: '询价日期',
      width: 200,
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return <span>{formatTime(text, 'YYYY-MM-DD')}</span>
      },
    },
    {
      key: 'expireDate',
      title: '询价截止日期',
      width: 200,
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        const status = getExpireDateStatus(record)
        return (
          <span className={status.className}>
            {formatTime(text, 'YYYY-MM-DD')}
            {status.text && <span> ({status.text})</span>}
          </span>
        )
      },
    },
    {
      key: 'purchaserName',
      title: '采购员',
      width: 100,
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },

    {
      key: 'materialCount',
      title: '物料条数',
      render(text: number, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text
      },
    },
    {
      key: 'statusText',
      title: '状态',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return getInquiryStatusName(text)
      },
    },
    {
      key: 'attachment',
      title: '附件',
      render(text: string, record: InquiryOrderItemDTO) {
        if (!record.__isFirstOfInquiry) return ''
        return text ? (
          <AttachmentPreview attachment={text} splitor={','} clickDownload />
        ) : (
          ''
        )
      },
    },
    {
      key: 'sortOrder',
      title: '序号',
      width: 80,
      render(text: number, record: InquiryOrderItemDTO, index: number) {
        return text ?? index + 1
      },
    },
    {
      key: 'itemStatusText',
      title: '明细状态',
      render(text: string) {
        return (
          <span
            className={supplierInquiryItemStatusEnum.getAttrByLabel(
              text as any,
              'className',
            )}
          >
            {text}
          </span>
        )
      },
    },
    {
      key: 'inquiryTaskNo',
      title: '来源唯一标识码',
      render(text: string) {
        return text || ''
      },
    },
    {
      key: 'clientMaterialName',
      title: '客方物料名称',
      render(text: string) {
        return text || ''
      },
    },
    {
      key: 'clientMaterialQty',
      title: '数量',
      width: 80,
      render(text: number) {
        return text || ''
      },
    },
  ]

  return (
    <div>
      <Search
        keyName={'INQUIRYLIST'}
        ScreenKey={'INQUIRYLIST'}
        fieldsData={fileListItems}
        onSearch={onSearch}
      />
      <div style={{ padding: '0 10px' }}>
        <div style={{ width: '40%', margin: '10px 0' }}>
          <RadioTabs
            defaultKey={String(statusSearchData)}
            radioItemDict={radioItemDict}
            onChange={(key) => handleStatusChange(Number(key))}
          />
        </div>
        <div style={{ margin: '10px 0' }}>
          <Row justify={'space-between'}>
            <Space size={'small'}>
              {tagsData.map((tag: TagType) => (
                <div
                  key={tag.value}
                  className={tag.checked ? 'filter-btn-active' : 'filter-btn'}
                  onClick={() => handleChange(tag.value)}
                >
                  {tag.label}
                </div>
              ))}
            </Space>
            <Space>
              <ImportTemplateModal
                buttonText="批量导入结果"
                modalTitle="批量导入结果"
                open={state.importModalOpen}
                onOpenChange={onImportOpenChange}
                confirmLoading={state.importConfirmLoading}
                onConfirm={onConfirmImport}
                downloadConfig={{
                  url: Template_url_inquiryImportSCP,
                }}
                uploadProps={{
                  dataSource: state.importUploadList,
                  onChange: onImportFileChange,
                  getOriginFile: getImportOriginFile,
                  type: 'inquiryImportSCP',
                }}
              />
              <AsyncButton onClick={onBatchExport}>批量导出</AsyncButton>
              <span ref={filterSlotRef} />
            </Space>
          </Row>
        </div>

        <TableAntd
          loading={loading}
          dataSource={dataSource.data}
          listColumn={getColumn}
          showSort
          Y={420}
          rowKey="inquiryItemId"
          filterType="咸亨询价单"
          ScreenColOnlyKey={['inquiryNo']}
          filterSlotRef={filterSlotRef}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
          onChangeCheck={onChangeCheck}
          showSize
        />
      </div>
    </div>
  )
}

export default XhQuotation
